<template>
  <div class="setting-language">
    <TitleBar :text="$t('SettingLanguage.topic')" :showIconButton="false" @clickCloseButton="clickCloseButton" />
    <div class="body">
      <div class="lang" @click="changeLanguageMode('th')">
        <label>{{ 'ภาษาไทย' }}</label>
        <img :src="util.getImagePath('')" :srcset="util.getImageSet('')" v-if="$i18n.locale === 'th'">
      </div>
      <div class="lang" @click="changeLanguageMode('en')">
        <label>{{ 'English' }}</label>
        <img :src="util.getImagePath('')" :srcset="util.getImageSet('')" v-if="$i18n.locale === 'en'">
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'

export default {
  name: 'SettingLanguage',
  components: {
    TitleBar
  },
  data () {
    return {
    }
  },
  methods: {
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    changeLanguageMode (language) {
      var self = this
      self.$i18n.locale = language
    }
  }
}
</script>

<style scoped>
  .setting-language {
    width: 230px;
    height: 140px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .body {
    height: 90px;
    box-sizing: border-box;
    background: rgb(255, 255, 255);
    position: relative;
    overflow: hidden;
    overflow-y: auto;
  }

  .body::-webkit-scrollbar-button {
    height: 12.5px;
  }
  .body::-webkit-scrollbar {
    background-color: rgb(251, 251, 251);
  }
  .body::-webkit-scrollbar-thumb {
    border: 2px solid rgb(251, 251, 251);
  }

  .lang {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;
  }

  .lang > label {
    cursor: pointer;
    font-weight: bold;
  }

  .lang > img {
    width: 24px;
    height: 24px;
  }

  @media only screen and (max-width: 768px) {
    .setting-language {
      width: 100%;
      min-width: 320px;
      height: 100%;
      border-radius: 0px;
    }

    .body {
      height: calc(100% - 50px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SettingLanguage.vue